import { render } from "./StockClientOrders.vue?vue&type=template&id=39edad65&scoped=true"
import script from "./StockClientOrders.vue?vue&type=script&lang=js"
export * from "./StockClientOrders.vue?vue&type=script&lang=js"

import "./StockClientOrders.vue?vue&type=style&index=0&id=39edad65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39edad65"]])

export default __exports__